import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from './ui/AppText';
import { CATEGORIES } from '../constants/categories';

const SIZE_STYLES = {
  small: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    fontSize: 10,
  },
  medium: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    fontSize: 12,
  },
  large: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    fontSize: 14,
  },
};

const CategoryBadge = ({ category, size = 'medium', showLabel = true }) => {
  const categoryData = CATEGORIES[category];
  const currentSize = SIZE_STYLES[size] || SIZE_STYLES.medium;

  // Hooks chamados INCONDICIONALMENTE (regra dos hooks); o early-return fica abaixo.
  const badgeStyle = useMemo(() => [
    styles.badge,
    {
      backgroundColor: (categoryData?.color || 'transparent') + '20',
      borderColor: categoryData?.color,
      paddingHorizontal: currentSize.paddingHorizontal,
      paddingVertical: currentSize.paddingVertical,
    },
  ], [categoryData?.color, currentSize.paddingHorizontal, currentSize.paddingVertical]);

  const dotStyle = useMemo(() => [
    styles.dot,
    { backgroundColor: categoryData?.color },
  ], [categoryData?.color]);

  const textStyle = useMemo(() => [
    styles.text,
    { color: categoryData?.color, fontSize: currentSize.fontSize },
  ], [categoryData?.color, currentSize.fontSize]);

  if (!categoryData) {
    return null;
  }

  return (
    <View style={badgeStyle}>
      <View style={dotStyle} />
      {showLabel && (
        <Text style={textStyle} numberOfLines={1}>
          {categoryData.label}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 20,
    borderWidth: 1,
    alignSelf: 'flex-start',
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginRight: 6,
  },
  text: {
    fontWeight: '600',
  },
});

// Memoiza o componente - só re-renderiza se props mudarem
export default React.memo(CategoryBadge);
